import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import styled from '@mui/material/styles/styled';

export const Container = styled('div')`
  position: relative;
`;

export const InternalCircularProgress = styled(CircularProgress)`
  color: ${({ theme }) => theme.palette.tags.greyLight};
`;

export const ExternalCircularProgress = styled(CircularProgress)`
  color: ${({ theme }) => theme.palette.primary.dark};
  animation-duration: 550ms;
  position: absolute;
  left: 0;

  & .${circularProgressClasses.circle} {
    stroke-linecap: round;
  }
`;
